'use client';

import { useEffect, useState } from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { DATA_KEYS } from '@/consts/dataKeys';
import { trackProductSelectionPageLoadEvents } from '@/helpers/productSelectionAndCheckout/helpers';

import { setPatientViewedAt } from '../js/setPatientViewedAt';

export const ProductSelectionSideEffects = () => {
  const { brand, treatmentCategory } = useFlowContext();

  const {
    hasViewedProductSelectionPage: initialHasViewedProductSelectionPageState,
  } = useDataProvider(DATA_KEYS.productSelection);

  const [hasViewedProductSelectionPage, setHasViewedProductSelectionPage] =
    useState(initialHasViewedProductSelectionPageState);

  useEffect(() => {
    setPatientViewedAt(
      brand,
      treatmentCategory,
      hasViewedProductSelectionPage,
      setHasViewedProductSelectionPage,
    );
  }, [brand, hasViewedProductSelectionPage, treatmentCategory]);

  useEffect(() => {
    trackProductSelectionPageLoadEvents(brand, treatmentCategory);
  }, [brand, treatmentCategory]);

  return null;
};
